import React, { useEffect } from 'react';

import Space from 'components/generic/Space.component';
import RELEASE from 'config/release.singleton';
import S from 'constants/string.const';
import useTip from 'hooks/useTip.hook';

import CN from './VersionBanner.module.scss';

const VersionBanner = () => {
  const { val: isVisible, set: setIsVisible } = useTip(false);

  useEffect(
    () =>
      RELEASE.subscribe(() => {
        RELEASE.isUpToDate().then((isUpToDate) => setIsVisible(!isUpToDate));
      }),
    [setIsVisible],
  );

  if (!isVisible) return null;

  return (
    <div className={CN.component}>
      <div className={CN.container}>
        <div className={CN.text}>
          <Space>{S.waitTriangle}</Space> Your Slick dashboard is out of date. Click reload for an instant update.
        </div>
        <div role="button" tabIndex={0} onClick={RELEASE.reload} className={CN.button}>
          RELOAD NOW
        </div>
      </div>
    </div>
  );
};

export default VersionBanner;
